export const 알람_쿼리키 = {
  알람: ['알람'] as const,
};
